<p-toast />
<p-toast (onClose)="onClose($event)" position="top-left" key="tl" />
<p-toast (onClose)="onClose($event)" position="top-center" key="tc" />
<p-toast (onClose)="onClose($event)" position="top-right" key="tr">
  <ng-template pTemplate="message" let-message>
    <div
      class="flex w-full flex-col gap-1"
      [class.cursor-pointer]="isActionableToast(message)"
      [class.select-none]="isActionableToast(message)"
      (click)="onToastClick(message)"
    >
      <div class="font-medium">{{ message.summary }}</div>
      <div>{{ message.detail }}</div>
      @if (isActionableToast(message)) {
        <div class="text-xs opacity-80 underline">Click to open</div>
      }
    </div>
  </ng-template>
</p-toast>
<p-toast (onClose)="onClose($event)" position="bottom-left" key="bl" />
<p-toast (onClose)="onClose($event)" position="bottom-center" key="bc" />
<p-toast (onClose)="onClose($event)" position="bottom-right" key="br" />
<p-toast (onClose)="onClose($event)" position="center" key="c" />
